<template>
  <container-files :container="container" :customer_id="customer_id" />
  <exportation-files :container="container" :customer_id="customer_id" />
  <div></div>
</template>

<script>
import ContainerFiles from "@/components/views/customer/query/basic_containers/show_container/ContainerFiles.vue";
import ExportationFiles from "@/components/views/customer/query/basic_containers/show_container/ExportationFiles.vue";

export default {
  name: "TabAttachments",
  props: {
    customer_id: {
      required: true
    },
    container: {}
  },
  components: {
    ContainerFiles,
    ExportationFiles
  }
};
</script>

<style></style>
